import * as React from 'react';
import { connect } from 'react-redux';

// Components
import ButtonLink from 'components/ButtonLink';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

interface IOwnProps {
    timesheetId: number;
}

interface IStateProps {}

interface IDispatchProps {
    updateQueryString: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class TimesheetApproveLink extends React.PureComponent<IProps> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        const { timesheetId } = this.props;
        this.props.updateQueryString({
            selectedTimesheet: timesheetId,
            timesheetApproveModal: true
        });
    };

    render() {
        return <ButtonLink onClick={this.handleClick}>Approve</ButtonLink>;
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    null,
    { updateQueryString }
)(TimesheetApproveLink);
